import { jsx as _jsx } from "react/jsx-runtime";
import { StyledTypography } from './BKJTypography.styled.js';
export const BKJTypography = ({ variant = 'Body', element = 'span', as: asProp, children, ...rest }) => {
    const resolvedAs = asProp || element;
    return (_jsx(StyledTypography, { as: resolvedAs, "$variant": variant, ...rest, children: children }));
};
//# sourceMappingURL=BKJTypography.js.map